(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bcm-mattress-shop]').forEach((root) => {
      if (root.dataset.bcmReady) return;
      root.dataset.bcmReady = 'true';
      const grid = root.querySelector('[data-bcm-mattress-grid]');
      const items = Array.from(grid.querySelectorAll('[data-bcm-mattress]'));
      items.forEach((item, index) => { item.dataset.order = String(index); });
      const group = root.querySelector('[data-bcm-group]');
      const size = root.querySelector('[data-bcm-size]');
      const sort = root.querySelector('[data-bcm-sort]');
      const vendor = root.querySelector('[data-bcm-vendor]');
      const budget = root.querySelector('[data-bcm-budget]');
      const feel = root.querySelector('[data-bcm-feel]');
      const normalizeSize = value => {
        const key = value.toLowerCase().replace(/[^a-z0-9]/g, '');
        return ({twin:'Twin',twinxl:'Twin XL',full:'Full',queen:'Queen',king:'King',californiaking:'California King',calking:'California King',splitking:'Split King'})[key] || value.trim();
      };
      const seenSizes = new Set();
      Array.from(size.options).forEach(option => {
        if (option.value === 'all') return;
        const normalized = normalizeSize(option.value);
        if (seenSizes.has(normalized)) { option.remove(); return; }
        seenSizes.add(normalized); option.value = normalized; option.textContent = normalized;
      });
      items.forEach(item => { item.bcmSizes = item.dataset.sizes.split('|').map(normalizeSize); });
      if (vendor) [...new Set(items.map(item => item.dataset.vendor).filter(Boolean))].sort().forEach(name => {
        const option = document.createElement('option'); option.value = name; option.textContent = name; vendor.append(option);
      });
      const count = root.querySelector('[data-bcm-count]');
      Array.from(group.options).forEach(option => {
        if (option.value !== 'all' && !items.some(item => item.dataset.group === option.value)) option.remove();
      });
      if (feel) [...new Set(items.map(item => item.dataset.feel).filter(Boolean))].sort().forEach(name => {
        const option = document.createElement('option'); option.value = name; option.textContent = name; feel.append(option);
      });
      const update = () => {
        let shown = 0;
        const bounds = (budget?.value || 'all').split(':');
        const min = bounds[0] === 'all' ? 0 : Number(bounds[0]);
        const max = bounds.length < 2 || bounds[1] === '' ? Infinity : Number(bounds[1]);
        items.sort((a, b) => sort.value === 'price-low' ? Number(a.dataset.price) - Number(b.dataset.price) : sort.value === 'price-high' ? Number(b.dataset.price) - Number(a.dataset.price) : Number(a.dataset.order) - Number(b.dataset.order));
        items.forEach((item) => {
          item.hidden = (group.value !== 'all' && item.dataset.group !== group.value) || (size.value !== 'all' && !item.bcmSizes.includes(size.value)) || (vendor && vendor.value !== 'all' && item.dataset.vendor !== vendor.value) || (feel && feel.value !== 'all' && item.dataset.feel !== feel.value) || Number(item.dataset.price) < min || Number(item.dataset.price) >= max;
          if (!item.hidden) shown += 1;
          grid.append(item);
        });
        count.textContent = shown === 1 ? count.dataset.countOne : count.dataset.countTemplate.replace('__COUNT__', String(shown));
        root.querySelector('[data-bcm-empty]').hidden = shown !== 0;
      };
      [group, size, sort, vendor, budget, feel].filter(Boolean).forEach((control) => control.addEventListener('change', update));
      root.querySelectorAll('[data-bcm-group-link]').forEach((link) => link.addEventListener('click', () => {
        group.value = link.dataset.bcmGroupLink;
        size.value = 'all'; if (vendor) vendor.value = 'all'; if (budget) budget.value = 'all'; if (feel) feel.value = 'all';
        update();
        root.querySelector('#bcm-mattress-products-title').focus({ preventScroll: true });
      }));
      root.querySelector('[data-bcm-reset]').addEventListener('click', () => {
        group.value = 'all'; size.value = 'all'; sort.value = 'price-high'; if (vendor) vendor.value = 'all'; if (budget) budget.value = 'all'; if (feel) feel.value = 'all'; update();
      });
      root.querySelectorAll('[data-bcm-open-group]').forEach((link) => link.addEventListener('click', () => {
        const details = root.querySelector(`#${link.dataset.bcmOpenGroup}`);
        if (details) details.open = true;
      }));
      root.querySelector('[data-bcm-controls]').hidden = false;
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
